const ptJSON = {
  Blueprints: 'Plantas',
  'Extended Sidebar': 'Barra lateral estendida',
  'Accent Sidebar': 'Barra Lateral de Acento',
  'Accent Header': 'Cabeçalho de destaque',
  'Boxed Sidebar': 'Barra lateral em caixa',
  'Collapsed Sidebar': 'Barra lateral recolhida',
  'Bottom Navigation': 'Navegação inferior',
  'Top Navigation': 'Navegação superior',
  'Lead Developer': 'Desenvolvedor-chefe',
  'Mega menu': 'Mega cardápio',
  Doctors: 'Doutores',
  Reference: 'Referência',
  Reports: 'Relatórios',
  'Custom dashboard built using the included components':
    'Painel personalizado construído usando os componentes incluídos',
  Hospital: 'Hospital',
  'field is required': 'campo obrigatório',
  Export: 'Exportação',
  'Bulk actions': 'Ações em massa',
  'Last year': 'Último ano',
  Expenses: 'Despesas',
  Products: 'Produtos',
  Statistics: 'Estatísticas',
  General: 'Geral',
  Automation: 'Automação',
  'Data Display': 'Exibir Dados',
  Calendar: 'Calendário',
  Mailbox: 'Caixa de Email',
  Dashboards: 'Dashboards',
  Analytics: 'Analytics',
  Banking: 'Bancário',
  Commerce: 'Comércio',
  Crypto: 'Crypto',
  Finance: 'Financeiro',
  Details: 'Detalhes',
  Fitness: 'Fitness',
  Healthcare: 'Cuidados de saúde',
  'Doctors Page': 'Pagína de Médicos',
  'Hospital Overview': 'Visão do Hospital',
  Helpdesk: 'Helpdesk',
  Learning: 'Aprendizado',
  Monitoring: 'Monitoramento',
  Tasks: 'Tarefas',
  'lot shipping': 'Envio de lote',
  Applications: 'Aplicações',
  'File Manager': 'Gerenciador de Arquivos',
  'Jobs Platform': 'Plataforma de trabalho',
  Messenger: 'Mensagem',
  Subsidy: 'Subsídio',
  'Monthly payment': 'Mensalidade',
  'Projects Board': 'Conselho de Projetos',
  Management: 'Gerenciamento',
  Users: 'Usuários',
  Parameters: 'Parâmetros',
  'Type of registration parameters': 'Tipo de parâmetros de cadastro',
  'Users - Management': 'Usuários - Gerenciamento',
  'Create Parameters': 'Criar Parâmetro',
  'Create user': 'Criar Usuário',
  'All users': 'Todos Usuários',
  'Search by name, email, cpf or application...':
    'Pesquise por nome, e-mail, cpf ou aplicação...',
  "We couldn't find any users matching your search criteria":
    'Não encontramos nenhum usuário que corresponda aos seus critérios de pesquisa',
  Username: 'nome de usuário',
  fullName: 'Nome completo',
  'Zip Code': 'CEP',
  Street: 'Endereço',
  Number: 'Número',
  Neighborhood: 'Bairro',
  City: 'Cidade',
  State: 'Estado',
  Country: 'País',
  Address: 'Endereço',
  'Cell Phone': 'Celular',
  'Phone Number': 'Número de Telefone',
  'The CPF field is required': 'O campo CPF é obrigatório',
  'Add new user': 'Adicionar novo usuário',
  'Fill in the fields below to create and add a new user to the site':
    'Preencha os campos abaixo para criar e adicionar um novo usuário',
  Name: 'Nome',
  Email: 'Email',
  Role: 'perfil',
  Actions: 'Ação',
  Administrators: 'Administradores',
  Subscribers: 'Assinantes',
  Customers: 'Cliente',
  'Create new parameter': 'Criar novo pârametro',
  'Fill in the fields below to create and add a new parameter':
    'Preencha os campos abaixo para criar um novo parâmetro',
  Cancel: 'Cancelar',
  'All aspects related to the app users can be managed from this page':
    'Todos os aspectos relacionados aos usuários do aplicativo podem ser gerenciados nesta página',
  'List All': 'Listar todos',
  List: 'Lista',
  'User Profile': 'Perfil de Usuário',
  'Users Management': 'Gerenciamento de Usuários',
  Projects: 'Projetos',
  Shop: 'Comprar',
  'Products List': 'Lista de Produtos',
  'View Product': 'Visualizar Produto',
  'Create Product': 'Criar Produto',
  Invoices: 'Notas Fiscais',
  'View Single': 'Ver individualmente',
  'Auth Pages': 'Páginas de Login',
  Login: 'Login',
  Basic: 'Básico',
  Cover: 'Cobrir',
  Register: 'Registro',
  Wizard: 'Mágico',
  'Recover Password': 'Recuperar Senha',
  Status: 'Status',
  Foundation: 'Fundação',
  'Extra Pages': 'Páginas Extras',
  'Error 404': 'Error 404',
  'Error 500': 'Error 500',
  'Coming Soon': 'Em breve',
  Maintenance: 'Manutenção',
  Overview: 'Visão Geral',
  'Layout Starters': 'Layout Inicial',
  'Starter Kit 1': 'Kit Inicial 1',
  'Starter Kit 2': 'Kit Inicial 1',
  'An unexpected error occurred': 'Ocorreu um erro inesperado',
  Documentation: 'Documentação',
  Welcome: 'Bem-Vindo',
  Help: 'Help',
  'Features tour': 'Tour de Recursos',
  'Getting started guide': 'Guia de Onboarding',
  'Contact support': 'Entre em Contato com o Suporte',
  Version: 'Versão',
  Search: 'Buscar',
  Notifications: 'Notificações',
  Settings: 'Definições',
  'Language Switcher': 'Alternar Idioma',
  'Sign out': 'Logout',
  'Switch laboratory': 'Trocar de laboratório',
  'Select a laboratory': 'Selecione um laboratório',
  'Could not select the laboratory': 'Não foi possível selecionar o laboratório',
  'Which laboratory do you want to work on? You can switch later from the user menu.':
    'Em qual laboratório você deseja trabalhar? Você pode trocar depois pelo menu do usuário.',
  Hello: 'Olá',
  'Current laboratory': 'Laboratório atual',
  'Search by name or code': 'Buscar por nome ou código',
  'No laboratory found': 'Nenhum laboratório encontrado',
  'Sign in with another account': 'Entrar com outra conta',
  'Change Theme': 'Mudar tema',
  'View all notifications': 'Ver todas as notificações',
  'Tokyo NextJS Typescript Admin Dashboard':
    'Painel de administração Tokyo NextJS Typescript',
  'High performance React template built with lots of powerful Material-UI components across multiple product niches for fast & perfect apps development processes':
    'Modelo React de alto desempenho construído com muitos componentes poderosos de Material-UI em vários nichos de produtos para processos de desenvolvimento de aplicativos rápidos e perfeitos',
  'Browse Live Preview': 'Visualização ao vivo via Browser',
  'Live Preview': 'Visualização ao vivo',
  'Key Features': 'Principais características',
  dashboards: 'dashboards',
  applications: 'aplicações',
  application: 'aplicação',
  Application: 'Aplicação',
  'management sections': 'gerenciamento de sessões',
  'dark/light themes': 'temas dark/light',
  components: 'componentes',
  'Some of the features that make Tokyo one of the best admin templates available today':
    'Alguns dos recursos que tornam Tóquio um dos melhores modelos de administração disponíveis atualmente',
  'Design Source Files': 'Arquivos de origem do design',
  'Start working on your project directly from one of the included starter kits or use the Figma/Sketch files to create a prototype first':
    'Comece a trabalhar em seu projeto diretamente de um dos kits iniciais incluídos ou use os arquivos Figma/Sketch para criar um protótipo primeiro',
  'We only translated a small part of the template, for demonstration purposes':
    'Traduzimos apenas uma pequena parte do modelo, para fins de demonstração',
  'Sign in': 'Login',
  'Fill in the fields below to sign into your account.':
    'Preencha os campos abaixo para entrar na sua conta',
  'Lost password?': 'Esqueceu a senha?',
  'Enter the email used for registration to reset your password.':
    'Digite o e-mail usado para o registro para redefinir sua senha.',
  'Send me a new password': 'Me envie uma nova senha',
  'Recuperar Senha': 'Recuperar Senha',
  'The password reset instructions have been sent to your email':
    'As instruções para redefinir a senha foram enviadas para o seu e-mail',
  'Check your email for further instructions':
    'Verifique seu e-mail para mais instruções',
  'Continue to login': 'Continuar para o login',
  'Want to try to sign in again?': 'Quer tentar entrar novamente?',
  'Click here': 'Clique aqui',
  'I accept the': 'Aceite os',
  'terms and conditions': 'Termos e Condições de uso.',
  'Don’t have an account, yet?': 'Não possui conta?',
  'Sign up here': 'Clique aqui',
  'Email address': 'Email',
  Password: 'Senha',
  'Types of Registers': 'Tipos de Registros',
  'Start Date': 'Data Início',
  'Finish Date': 'Data Fim',
  'Freeze date': 'Data Congelamento',
  "Beneficiary's name": 'Nome do Beneficiário',
  Beneficiary: 'Beneficiário',
  'Cellphone must be 11 digits': 'O celular tem que ter 11 dígitos',
  'Error creating user':
    'Ocorreu um erro ao criar o usuário, verifique os dados e tente novamente',
  Matriculation: 'Matricula',
  'Only singles example MG': 'Apenas siglas exemplo MG',
  jobtitle: 'Cargo',
  'The user account was created successfully':
    'A conta de usuário foi criada com sucesso',
  Roles: 'Perfis',
  'CPF must be 11 digits': 'CPF precisa ter 11 dígitos',
  'invalid CPF': 'CPF inválido',
  'The email provided should be a valid email address':
    'O e-mail fornecido deve ser um endereço de e-mail válido',
  Value: 'Valor',
  'Write value...': 'Escreva um valor',
  Observation: 'Observação',
  CLIENT: 'CLIENTE',
  'Required field': 'Campo Obrigatório',
  'Invalid date': 'Data Inválida',
  'Write a observetion': 'Escreva uma observação',
  'There is an error': 'Ocorreu um erro',
  'The parameter was created successfully':
    'O parâmetro foi criado com sucesso',
  'Please try again': 'Por favor, tente novamente',
  'Freezing age': 'Congelamento Idade',
  'Judicial decision': 'Decisão Judicial',
  "We couldn't find any parameters matching your search criteria":
    'Não encontramos nenhum parâmetro que corresponda aos seus critérios de pesquisa',
  'Register Type': 'Tipo de Registro',
  All: 'Todos',
  all: 'TODOS',
  ALL: 'TODOS',

  'Search by Start Date, Finish, Free ou Matriculation...':
    'Procure por Data Início, Fim, Congelamento ou Matricula',
  'Expired Login': 'Login Expirado',
  'Laboratory - Management': 'Laboratório - Gerenciamento',
  'Company Name': 'Razão Social',
  Consultant: 'Consultor',
  'The laboratory has been removed': 'O laboratório foi removido',
  'The laboratory was created successfully':
    'O laboratório foi criado com sucesso',
  'Error creating laboratory': 'Ocorreu um erro ao criar o laboratório',
  'Search by company name, code, cnpj or consultant...':
    'Pesquisar por nome da empresa, código, cnpj ou consultor...',
  "We couldn't find any laboratory matching your search criteria":
    'Não encontramos nenhum laboratório que corresponda aos seus critérios de pesquisa',
  'Select all laboratories': 'Selecionar todos os laboratórios',
  laboratories: 'laboratórios',
  laboratory: 'laboratório',
  'Choose between table or grid views for displaying the users list.':
    'Escolha entre tabela ou grade para exibir a lista de usuários.',
  'Choose between table or grid views for displaying the laboratories list.':
    'Escolha entre tabela ou grade para exibir a lista de laboratórios.',
  'Are you sure you want to permanently delete this user account':
    ' Você tem certeza de que deseja excluir permanentemente esta conta de usuário',
  'Are you sure you want to permanently delete this laboratory':
    'Você tem certeza de que deseja excluir permanentemente este laboratório',
  'Rows per page': 'Linhas por página',
  'Laboratories Management': 'Gerenciamento de Laboratórios',
  'All aspects related to the app laboratories can be managed from this page':
    'Todos os aspectos relacionados aos laboratórios do aplicativo podem ser gerenciados nesta página',
  'Create laboratory': 'Criar laboratório',
  'Add new laboratory': 'Adicionar novo laboratório',
  'Fill in the fields below to create and add a new laboratory':
    'Preencha os campos abaixo para criar e adicionar um novo laboratório',
  Code: 'Código',
  'Invalid status': 'Status inválido',
  'invalid CNPJ': 'CNPJ inválido',
  'CNPJ must be 14 digits': 'CNPJ tem que ter 14 dígitos',
  Delete: 'Excluir',
  Laboratory: 'Laboratório',
  'General Information': 'Informações Gerais',
  Contact: 'Contato',
  Audit: 'Auditoria',
  'Details about the laboratory': 'Detalhes sobre o laboratório',
  'Details about how to contact the laboratory':
    'Detalhes sobre como entrar em contato com o laboratório',
  'Details about who created and updated this record':
    'Detalhes sobre quem criou e atualizou este registro',
  Cellphone: 'Celular',
  'Created By': 'Criado por',
  'Created At': 'Criado em',
  'Updated By': 'Atualizado por',
  'Updated At': 'Atualizado em',
  'The email field is required': 'O campo de e-mail é obrigatório',
  'The password field is required': 'O campo de senha é obrigatório',
  'At least one role is required': 'Pelo menos um perfil é obrigatório',
  'Analytics Dashboard': 'Painel de Controle de Análise',
  'Personal Details': 'Detalhes Pessoais',
  'Manage informations related to personal details':
    'Gerenciar informações relacionadas aos detalhes pessoais',
  'Contact Information': 'Informações de Contato',
  'Details about how to contact the user':
    'Detalhes sobre como entrar em contato com o usuário',
  'Status and Role': 'Status e perfil',
  "Details about the user's status and role":
    'Detalhes sobre o status e a perfil do usuário',
  'The user was removed successfully': 'O usuário foi removido com sucesso',
  'Error removing user': 'Ocorreu um erro ao remover o usuário',
  'The user was updated successfully': 'O usuário foi atualizado com sucesso',
  "Details about the user's laboratory":
    'Detalhes sobre o laboratório do usuário',
  'Job Title': 'Cargo',
  View: 'Visualizar',
  'Go to': 'Ir para',
  'Details about the laboratory address':
    'Detalhes sobre o endereço do laboratório',
  'The full name must not contain numbers':
    'O nome completo não pode conter números',
  'The full name must contain at least two words':
    'O nome completo deve conter pelo menos duas palavras',
  'Password must contain at least one special character':
    'Senha deve conter pelo menos um caractere especial',
  'Password must contain at least one number':
    'Senha deve conter pelo menos um número',
  'Password must be at most 100 characters long':
    'A senha deve ter no máximo 100 caracteres de comprimento',
  'Password must be at least 8 characters long':
    'Senha deve ter pelo menos 8 caracteres de comprimento',
  Edit: 'Editar',
  'Error edit laboratory':
    'Ocorreu um erro ao editar o laboratório, verifique os dados e tente novamente',
  'Edit laboratory': 'Editar laboratório',
  'Edit laboratory information': 'Editar informações do laboratório',
  'Edit user': 'Editar usuário',
  'Edit user information': 'Editar informações do usuário',
  'Error edit user':
    'Ocorreu um erro ao editar o usuário, verifique os dados e tente novamente',
  'The laboratory was updated successfully':
    'O laboratório foi atualizado com sucesso',
  'External Links': 'Links Externos',
  'Useful Links': ' Links Úteis',
  'Here you can find links to various resources and tools that can help you in your work':
    'Aqui você encontra links para diversos recursos e ferramentas que podem ajudá-lo em seu trabalho',
  'Access Control': 'Controle de Acesso',
  'The role has been removed': 'O perfil foi removido',
  'The role was created successfully': 'O perfil foi criado com sucesso',
  'Error creating role': 'Ocorreu um erro ao criar o perfil',
  'Role Name': 'Nome do Perfil',
  'Search by role name...': 'Pesquisar por nome do perfil...',
  "We couldn't find any roles matching your search criteria":
    'Não encontramos nenhum perfil que corresponda aos seus critérios de pesquisa',
  'Select all roles': 'Selecionar todos os perfis',
  'Roles Management': 'Gerenciamento de Perfis',
  'Choose between table or grid views': 'Escolha entre tabela ou grade',
  'Are you sure you want to permanently delete this role':
    'Você tem certeza de que deseja excluir permanentemente este perfil',
  'Manage your roles, and permissions to control access to resources':
    'Gerencie seus perfis e permissões para controlar o acesso aos recursos',
  'Create role': 'Criar perfil',
  'Read User': 'Ler Usuário',
  'Allows reading user information': 'Permite ler informações do usuário',
  'Update User': 'Atualizar Usuário',
  'Allows updating user information':
    'Permite atualizar informações do usuário',
  'Create User': 'Criar Usuário',
  'Allows creating new users': 'Permite criar novos usuários',
  'Delete User': 'Excluir Usuário',
  'Allows deleting users': 'Permite excluir usuários',
  'Read Laboratory': 'Ler Laboratório',
  'Allows reading laboratory information':
    'Permite ler informações do laboratório',
  'Update Laboratory': 'Atualizar Laboratório',
  'Allows updating laboratory information':
    'Permite atualizar informações do laboratório',
  'Create Laboratory': 'Criar Laboratório',
  'Allows creating new laboratories': 'Permite criar novos laboratórios',
  'Delete Laboratory': 'Excluir Laboratório',
  'Allows deleting laboratories': 'Permite excluir laboratórios',
  'Read Role': 'Ler perfil',
  'Allows reading role information': 'Permite ler informações do perfil',
  'Update Role': 'Atualizar perfil',
  'Allows updating role information': 'Permite atualizar informações do perfil',
  'Create Role': 'Criar perfil',
  'Allows creating new roles': 'Permite criar novas funções',
  'Delete Role': 'Excluir perfil',
  'Allows deleting roles': 'Permite excluir funções',
  'No description available': 'Nenhuma descrição disponível',
  'Role Description': 'Descrição do Perfil',
  'Add new role': 'Adicionar novo perfil',
  'Fill in the fields below to create and add a new role':
    'Preencha os campos abaixo para criar e adicionar um novo perfil',
  Permissions: 'Permissões',
  'Role name is required': 'O nome do perfil é obrigatório',
  'Role name must be at least 3 characters':
    'O nome do perfil deve ter pelo menos 3 caracteres',
  'Role name must not exceed 50 characters':
    'O nome do perfil não deve exceder 50 caracteres',
  'Permission ID is required': 'O ID da permissão é obrigatório',
  'At least one permission must be selected':
    'Pelo menos uma permissão deve ser selecionada',
  'Permissions are required': 'As permissões são obrigatórias',
  'Role created successfully': 'Perfil criado com sucesso',
  'View/Edit': 'Visualizar/Editar',
  'Role Details': 'Detalhes do Perfil',
  'Manage informations related to role details':
    'Gerencie informações relacionadas aos detalhes do perfil',
  'Edit role': 'Editar perfil',
  'Edit role information': 'Editar informações do perfil',
  'Role updated successfully': 'perfil atualizado com sucesso',
  'Error update role': 'Erro ao atualizar perfil',
  'Role deleted successfully': 'Perfil excluído com sucesso',
  'Error deleting role': 'Erro ao excluir perfil',
  'Are you sure you want to delete this role?':
    'Você tem certeza de que deseja excluir este perfil?',
  'User deleted successfully': 'Usuário excluído com sucesso',
  'Error deleting user': 'Erro ao excluir usuário',
  'Are you sure you want to delete this user?':
    'Você tem certeza de que deseja excluir este usuário?',
  'Laboratory deleted successfully': 'Laboratório excluído com sucesso',
  'Error deleting laboratory': 'Erro ao excluir laboratório',
  'Fail to recovery permissions': 'Falha ao recuperar permissões',
  'User does not have a laboratory linked':
    'Usuário não possui laboratório vinculado',
  'Code must be unique': 'O código deve ser único',
  'CNPJ must be unique': 'O CNPJ deve ser único',
  'Open Ticket': 'Abrir Chamado',
  'An error occurred while trying to recover the password. Please try again later.':
    'Ocorreu um erro ao tentar recuperar a senha. Por favor, tente novamente mais tarde.',
  'Reset Password': 'Redefinir Senha',
  'New Password': 'Nova Senha',
  'Confirm Password': 'Confirmar Senha',
  'An error occurred while resetting the password':
    'Ocorreu um erro ao redefinir a senha',
  'Password reset successfully': 'Senha redefinida com sucesso',
  'Populate the area and subject fields to open a help desk ticket':
    'Preencha os campos de área e assunto para abrir um chamado na central de ajuda',
  'Fill in the fields below to reset your password.':
    'Preencha os campos abaixo para redefinir sua senha.',
  'We inform you that to access the Price Table, grouping and exam deadline information, our customers must access the Shift_eLIS system and log in to the system': `Informamos que para acesso as informações de Tabela de Preço, Agrupamento e Prazo de Exames, nossos clientes devem acessar o sistema Shift e-LIS e logar no sistema`,
  'PRICE TABLE AND GROUPING': 'TABELA DE PREÇO E AGRUPAMENTO',
  'Read File': 'Ler Arquivo',
  'Update File': 'Atualizar Arquivo',
  'Create File': 'Criar Arquivo',
  'Delete File': 'Excluir Arquivo',
  'Allows updating file information':
    'Permite atualizar informações do arquivo',
  'Allows reading file information': 'Permite ler informações do arquivo',
  'Allows creating new files': 'Permite criar novos arquivos',
  'Allows deleting files': 'Permite excluir arquivos',
  FILES: 'ARQUIVOS',
  'Download the files made available here':
    'Baixe os arquivos disponibilizados aqui',
  Services: 'Serviços',
  Service: 'Serviço',
  'Open Tickets': 'Abertura de Chamados',
  'Access Profiles': 'Perfis de Acesso',
  'Please enter a valid phone number. Use the format (XX) XXXXX-XXXX for mobile phones or (XX) XXXX-XXXX for landlines':
    'Por favor, insira um número de telefone válido. Use o formato (XX) XXXXX-XXXX para celulares ou (XX) XXXX-XXXX para telefones fixos',
  'Request Type': 'Tipo de Solicitação',
  Process: 'Processo',
  Tickets: 'Chamados',
  'View and manage all Tickets': 'Visualize e gerencie todos os Chamados',
  'Ticket Number': 'Número do Chamado',
  'Search by ticket number, area, patient name, service order, request type or process description...':
    'Pesquisar por número do chamado, área, nome do paciente, ordem de serviço, tipo de solicitação ou descrição do processo...',
  'Request date': 'Data da solicitação',
  Comments: 'Comentários',
  'Type your comment...': 'Digite seu comentário...',
  Send: 'Enviar',
  'Comment is required': 'Comentário é obrigatório',
  'Comment cannot be empty': 'Comentário não pode estar vazio',
  'Ticket Information': 'Informações do Chamado',
  "We couldn't find any ticket matching your search criteria":
    'Não conseguimos encontrar nenhum chamado que corresponda aos seus critérios de pesquisa',
  Attachments: 'Anexos',
  'No attachments available': 'Nenhum anexo disponível',
  Add: 'Adicionar',
  'Upload Attachment': 'Enviar Anexo',
  'Attachment Type': 'Tipo de Anexo',
  'Attachment type is required': 'Tipo de anexo é obrigatório',
  Description: 'Descrição',
  'Optional description for the file': 'Descrição opcional para o arquivo',
  'Click to select a file': 'Clique para selecionar um arquivo',
  'Please select a file': 'Por favor, selecione um arquivo',
  'Please select an attachment type': 'Por favor, selecione um tipo de anexo',
  'Error uploading file. Please try again.':
    'Erro ao enviar arquivo. Por favor, tente novamente.',
  Upload: 'Enviar',
  'Uploading...': 'Enviando...',
  'Loading...': 'Carregando...',
  'Create Ticket': 'Abrir Chamado',
  'Read Ticket': 'Ler Chamado',
  'Update Ticket': 'Atualizar Chamado',
  'Delete Ticket': 'Excluir Chamado',
  'Allows creating ticket': 'Permite abrir novos chamados',
  'Allows reading ticket': 'Permite ler informações do chamado',
  'Allows updating ticket': 'Permite atualizar informações do chamado',
  'Allows deleting tickets': 'Permite excluir chamados',
  area: 'área',
  AREA: 'ÁREA',
  Area: 'Área',
  'File Name': 'Nome do Arquivo',
  Filters: 'Filtros',
  'Export CSV': 'Exportar CSV',
  Column: 'Coluna',
  Contains: 'Contém',
  Equals: 'Igual a',
  'Not equals': 'Diferente de',
  'Starts with': 'Começa com',
  'Ends with': 'Termina com',
  Value: 'Valor',
  'Add filter': 'Adicionar filtro',
  'Advanced Search': 'Busca Avançada',
  'Clear Filters': 'Limpar Filtros',
  Active: 'Ativo',
  Inactive: 'Inativo',
  Application: 'Aplicação',
  Backoffice: 'Backoffice',
  Client: 'Cliente',
  Close: 'Fechar',
  'Search by file name or type...': 'Pesquisar por nome ou tipo de arquivo...',
  'Document Type': 'Tipo de Documento',
  All: 'Todos',
  Documentos: 'Documentos',
  Certificados: 'Certificados',
  'Formulários': 'Formulários',
  // Financial - Invoices
  'Manage all issued invoices': 'Gerencie todas as notas fiscais emitidas',
  'Upload Invoices': 'Enviar Notas Fiscais',
  'Upload XML and PDF invoice files. You can select multiple files at once.':
    'Envie arquivos de nota fiscal XML e PDF. Você pode selecionar vários arquivos de uma vez.',
  'File "{{name}}" has an invalid extension. Only XML and PDF files are allowed.':
    'O arquivo "{{name}}" possui uma extensão inválida. Somente arquivos XML e PDF são permitidos.',
  'Please select at least one file':
    'Por favor, selecione pelo menos um arquivo',
  'Error uploading invoices': 'Erro ao enviar notas fiscais',
  'Click to select XML and PDF files':
    'Clique para selecionar arquivos XML e PDF',
  'Only .xml and .pdf files are accepted':
    'Somente arquivos .xml e .pdf são aceitos',
  'Selected files': 'Arquivos selecionados',
  'Uploading invoices...': 'Enviando notas fiscais...',
  'Invoice Number': 'Número da Nota Fiscal',
  Company: 'Empresa',
  'Search by invoice number or competece...':
    'Pesquisar por número da nota fiscal ou competência...',
  "We couldn't find any invoices matching your search criteria":
    'Não encontramos nenhuma nota fiscal correspondente aos seus critérios de pesquisa',
  financial: 'financeiro',
  Financial: 'Financeiro',
  'Read Financial': 'Ler Financeiro',
  'Allows reading financial data': 'Permite ler dados financeiros',
  'Read Invoice': 'Ler Nota Fiscal',
  'Allows reading invoice data': 'Permite ler dados de nota fiscal',
  'Create Invoice': 'Criar Nota Fiscal',
  'Allows creating invoice data': 'Permite criar dados de nota fiscal',
  Extension: 'Extensão',
  Competence: 'Competência',
  'Search permissions...': 'Pesquisar permissões...',
  Receipts: 'Faturas',
  'View your receipts': 'Visualize suas faturas',
  'Patient Name': 'Nome do Paciente',
  'Service Order': 'Ordem de Serviço',
  'Allows reading receipt': 'Permite ler Fatura',
  'Read Receipt': 'Ler Fatura',
  receipt: 'fatura',
  'Resend password email': 'Reenviar email de senha',
  'Are you sure you want to resend the password email to this user?':
    'Tem certeza que deseja reenviar o email de senha para este usuário?',
  Resend: 'Reenviar',
  'Password recovery email sent successfully': 'Email de recuperação de senha enviado com sucesso',
  'Error sending password recovery email': 'Erro ao enviar email de recuperação de senha',
};

export default ptJSON;
